import { useInjection } from 'inversify-react';
import { useMemo } from 'react';

import { ThemeProvider } from '@desygner/ui-common-components';
import { ErrorBoundary } from '@desygner/ui-core-monitoring';

import { ITheme } from '../inversify.config';
import { TYPES } from '../inversify.types';
import { Layout } from '../layout';
import { Viewer } from '../layout/pages';
import { TranslationProvider } from '../providers/TranslationProvider';
import { IViewerStoreInjector } from '../store';
import { applyBrandingToTheme } from '../utils/theme.utils';
import { GlobalStyle } from './app.styles';

export function App() {
  const injectedTheme = useInjection<ITheme>(TYPES.Theme);
  const useViewerStore = useInjection<IViewerStoreInjector>(TYPES.Store.Viewer);
  const themeVersion = useViewerStore((state) => state.theme);
  const company = useViewerStore((state) => state.company);

  const theme = useMemo(() => {
    const hasWhiteLabelConfiguration =
      company?.is_workspace &&
      'white_label_configuration' in company &&
      company.white_label_configuration;
    const brandColor = hasWhiteLabelConfiguration
      ? company.white_label_configuration.colors?.highlight
      : undefined;

    return applyBrandingToTheme({
      injectedTheme,
      themeVersion,
      brandColor,
    });
  }, [themeVersion, company, injectedTheme]);

  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <TranslationProvider>
          <GlobalStyle theme={theme} />
          <Layout>
            <Viewer />
          </Layout>
        </TranslationProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
